module.exports = __webpack_public_path__ + "img/how_it_works_icon_3.13715f53.png";